import dayjs from 'dayjs'

import { timeHhMmSsToDayjs } from '@/shared/lib/timeHelper'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getDefaultValueByFieldType = (defaultValue: any, fieldType: string): any => {
  if (fieldType === 'date') {
    const defaultDate = defaultValue ? dayjs(defaultValue, 'DD/MM/YYYY') : null

    return defaultDate
  }

  if (fieldType === 'time') {
    const defaultTime = defaultValue ? timeHhMmSsToDayjs(defaultValue) : timeHhMmSsToDayjs('00:00:00')

    return defaultTime
  }

  if (fieldType === 'select') {
    if (!defaultValue) {
      return null
    }

    return defaultValue
  }

  if (!defaultValue) {
    return defaultValue
  }

  return defaultValue
}